/*
This class uses the toastr library which is already loaded in app.js
*/

class ToastManager {
    success(header, message) {
        window.notyf.success(`✅ ${header}${message ? ': ' + message : ''}`);
    }
    error(header, message) {
        window.notyf.error(`❌ ${header}${message ? ': ' + message : ''}`);
    }
    info(header, message) {
        window.notyf.open({ type: 'info', message: `ℹ️ ${header}${message ? ': ' + message : ''}` });
    }
    warning(header, message) {
        window.notyf.open({ type: 'warning', message: `⚠️ ${header}${message ? ': ' + message : ''}` });
    }
}

module.exports = ToastManager;
